<app-wizard-step-card (next)="onNext()" [canPrevious]="false" [canNext]="false" [showStepIndication]="false">
    <app-empty-state [direction]="uiDirection.Horizontal">
        <app-svg-illustration [svg]="illustrations.EnergyBulb" [context]="uiContext.Accent"></app-svg-illustration>
        <h5>{{ 'ITS_A_WRAP' | translate }}</h5>
        <div empty-state-info>
            <app-todo [label]="'ENERGY_OFFER_SENT' | i18nKeyTranslate: i18nKeys.RealEstateAgentTodo" [checked]="true">
                <app-todo-template *todoStateChecked>
                    <span class="u-font-small u-color-muted">{{ 'BY_EMAIL' | translate}}</span>
                </app-todo-template>
            </app-todo>
            <app-todo
                *ngIf="energyStopStore.energyStop().states?.suppliersStatus !== EnergyStopSuppliersStatus.Complete && move.linkedMove"
                [label]="'LEAVER_SUPPLIERS_REQUESTED' | i18nKeyTranslate: i18nKeys.RealEstateAgentTodo"
                [checked]="true"
            >
                <app-todo-template *todoStateChecked>
                    <span class="u-font-small u-color-muted">{{ 'BY_EMAIL' | translate}}</span>
                </app-todo-template>
            </app-todo>
        </div>
        <button app-button type="submit">{{ 'VIEW_TRANSACTION' | translate }}</button>
    </app-empty-state>
</app-wizard-step-card>
